export const saveGridStateToSessionStorage = (gridStateKey, newState) => {
    const { rows, ...stateToSave } = newState;
    let data = JSON.stringify(stateToSave);
    try {
        sessionStorage.setItem(gridStateKey, data);
    } catch (err) {
        console.error(`Could not save ${gridStateKey} DataGrid state with data size: ${(data.length / 1024).toFixed(2)} KB`, err);
    }
}